import { css } from "@compiled/react";

const backgroundStyle = css({
    position: "absolute",
    insetInlineStart: 0,
    insetBlockEnd: 0,
    width: "100vw",
    maxWidth: "100vw",
    minWidth: "750px",
    zIndex: -1
});

export const Background = () => {
    return (
        <svg
            css={backgroundStyle}
            width="1440"
            height="900"
            viewBox="0 0 1440 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M789.13 1872.04C965.261 1810.52 1109.36 1831.72 1247.84 1924.87C1398.51 2026.22 1474.44 2166.31 1480.18 2336.89L2764.78 3200.99C3259.46 2083.95 3014.99 1156.25 2171.57 588.917C1386.05 60.5259 585.163 101.12 -487 1013.63L789.468 1872.27L789.13 1872.04Z"
                fill="#CFE1FD"
            />
        </svg>
    );
};
